'use client';

import { FC } from 'react';

export interface SelectOption {
    value: string;
    label: string;
}

export interface SelectProps {
    id?: string;
    name?: string;
    placeholder?: string;
    onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    value: string;
    testId?: string;
    extendedClassName?: string;
    options: SelectOption[];
    error?: boolean;
    disabled?: boolean;
}

const Select: FC<SelectProps> = (props) => {
    const { id, name, placeholder, onChange, value, testId, extendedClassName, options, error, disabled } = props;

    const defaultClassName =
        'select !bg-white !border !border-custom-grey-5 !text-[#000] px-4 !rounded-none focus:outline-none focus:border-[#86b7fe] focus:shadow-[inset_0_1px_1px_rgba(0,0,0,0.08),0_0_8px_rgba(102,175,233,0.6)] py-[8px] pr-[40px] pl-[12px] min-h-[48px] leading-[1.75] text-[16px]';

    // Error
    let errorClassNames = '';
    if (error) {
        errorClassNames = 'select-error';
    }

    const selectClassNames = [defaultClassName, extendedClassName, errorClassNames].join(' ');

    return (
        <select
            id={id}
            name={name}
            className={selectClassNames}
            data-test-id={testId}
            onChange={onChange}
            value={value}
            disabled={disabled}
        >
            {placeholder && (
                <option disabled={true} className={'!rounded-none !px-0 !py-[3px]'}>
                    {placeholder}
                </option>
            )}
            {options.map((option) => (
                <option
                    key={option.value}
                    value={option.value}
                    className={'!rounded-none !px-0 !py-[3px] hover:!bg-custom-grey-3'}
                >
                    {option.label}
                </option>
            ))}
        </select>
    );
};

export default Select;
